import React, { useEffect, useRef, useState } from "react";
import queryString from 'query-string';
import { useReactToPrint } from "react-to-print";

// reactstrap components
import { Button, Card, CardBody, Row, Col } from "reactstrap";

// services
import { showMessage } from "../../services/message.js";
import { api_GET } from "../../services/api_service.js";
import { formateDate } from "../../helpers/formats";

// components
import LogoSistema from "../../components/LogoSistema/LogoSistema";

//Context
import { useAuth } from "../../context/auth";

/**
 * Certidão de Destinação Final (Gerador RSS).
 * O texto chega da API já com as variáveis do modelo resolvidas.
 */
export default function CertidaoDestinacaoFinalRSS({ history }) {
    const { setLoading } = useAuth();

    const [certidao, set_certidao] = useState(null);

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        copyStyles: true
    });

    const loadDados = () => {
        let urls = history.location.search;
        let params = queryString.parse(urls);

        if (params.protocolo == null || params.requerimento == null) {
            showMessage("Aviso", "Certidão não informada!", 'error', null);
            return;
        }

        setLoading(true);
        api_GET('Requerimento/GetCertidaoPorNumero/' + encodeURIComponent(params.protocolo) + '/' + encodeURIComponent(params.requerimento))
            .then(result => set_certidao(result.data))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadDados();
    }, []);

    return (
        <>
            {certidao != null &&
                <div className="d-flex flex-column justify-content-center align-items-center">
                    <div className="mt-3 mb-3">
                        <Button color="success" type="button" onClick={handlePrint}>
                            <i className="fas fa-print"></i>  Imprimir
                        </Button>
                    </div>
                    <Card style={{ width: "100%", height: "29.7cm" }} innerRef={componentRef}>
                        <CardBody>
                            <div style={{ border: "1px solid black", padding: "0.5cm", height: "100%" }}>
                                <Row style={{ borderBottom: "1px solid black", alignItems: "center" }}>
                                    <Col md="3" style={{ justifyContent: "center" }}>
                                        <LogoSistema identificacaoLogo={"logotipo"} width='150' style={{ marginTop: "10px", marginBottom: "10px" }} />
                                    </Col>
                                    <Col md="6" className="text-center">
                                        <h5 style={{ marginTop: "10px", marginBottom: "5px" }}><strong>Agência Reguladora de Serviços Públicos </strong></h5>
                                        <h5 style={{ marginBottom: "10px" }}><strong>do Município de São Paulo</strong></h5>
                                    </Col>
                                    <Col md="3" className="text-right" style={{ justifyContent: "center" }}>
                                        <LogoSistema identificacaoLogo={"logoSecundario"} width='160rem' />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12" className="text-center mt-2">
                                        <h3 style={{ marginBottom: "5px" }}><b>Certidão de Destinação Final</b></h3>
                                        {certidao.sigla != null &&
                                            <h5 style={{ marginBottom: "10px" }}><b>{certidao.sigla}</b></h5>
                                        }
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12" className="mt-3">
                                        <div style={{ whiteSpace: "pre-wrap", textAlign: "justify" }}>
                                            {certidao.textoCertidao}
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col md="6">
                                        <b>Número da Solicitação: </b>{certidao.numeroRequerimento}
                                    </Col>
                                    <Col md="6" className="text-right">
                                        <b>Número do Processo: </b>{certidao.numeroProcessoSEI}
                                    </Col>
                                </Row>
                                {certidao.dataPublicacao != null &&
                                    <Row className="mt-2">
                                        <Col md="12" className="text-right">
                                            <b>Data de Publicação: </b>{formateDate(certidao.dataPublicacao)}
                                        </Col>
                                    </Row>
                                }
                            </div>
                        </CardBody>
                    </Card>
                </div>
            }
        </>
    );
}
